const events = [
  {
    title: 'Shane Pope',
    subtitle: 'Building What Comes Next',
    label: 'AIPosse Conversation',
    image: '/events/shane-pope.svg',
    accent: '#f6d541'
  },
  {
    title: 'Chad Cook',
    subtitle: 'Operators, Systems & Scale',
    label: 'Founder Session',
    image: '/events/chad-cook.svg',
    accent: '#f49558'
  },
  {
    title: 'Disarming AI',
    subtitle: 'Beyond Fear. Into Leverage.',
    label: 'Live AI Mastermind',
    image: '/events/disarming-ai.svg',
    accent: '#409fa1'
  },
  {
    title: 'Smart Connect',
    subtitle: 'Relationships With Signal',
    label: 'Member Event',
    image: '/events/smart-connect.svg',
    accent: '#f6d541'
  },
  {
    title: 'Founders Roundup',
    subtitle: 'Builders Compare Notes',
    label: 'Private Conversation',
    image: '/events/founders-roundup.svg',
    accent: '#d35e0e'
  }
];

export default events;